import { useContext } from 'react'
import { SignupContext } from '../contexts'

export const useSignupContext = () => useContext(SignupContext)
